export default "__VITE_ASSET__D6qLO9xN__"